import { css } from 'lit';
export const ImageDisplayCss = css `
  :host {
    width: 100%;
    height: 100%;
  }  

  



  .image-container {
    position: relative;
    width: 100%;
    height: 100%;
    border: 2px dashed #d1d5db;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 20px;
    box-sizing: border-box;
    cursor: pointer;
    transition: border-color 0.2s, background-color 0.2s;
    overflow: hidden; /* Hide anything that spills out */
    background-color: #f9fafb;
    color: #4b5563;
  }

  .image-container.dragging-over {
    border-color: #3b82f6;
    background-color: #eff6ff;
  }

  /* When an image is successfully loaded, remove padding/border for a clean look */
  .image-container.has-preview {
    border: 0;
    padding: 0;
    cursor: default;
    background-color: #f3f4f6;
  }
  
  .image-container.transparent-bg {
    background-color: transparent !important;
  }

  .image-container .content-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    pointer-events: none; /* Allows clicks to pass through to the container */
  }

  /* Let the button inside the wrapper be clickable */
  .image-container.has-preview .content-wrapper {
      pointer-events: auto;
  }
  
  .image-container .icon {
    /* Use percentages to make the icon scale with the container */
    width: 25%;
    height: 25%;
    /* Keep the blue color */
    color: #3b82f6; 
    margin-bottom: 12px;
  }
  .image-container .prompt {
    font-size: 1.125rem;
    font-weight: 600;
  }
  
  .image-container .support-text {
    font-size: 0.875rem;
    color: #6b7280;
    margin-top: 4px;
  }

  .image-container .error-icon {
    color: #ef4444;
  }

  .image-container .error-message {
      color: #ef4444;
      margin: 8px 0;
      font-size: 0.875rem;
  }

  .image-container .try-again-button {
      background-color: #3b82f6;
      color: white;
      border: none;
      padding: 8px 16px;
      border-radius: 6px;
      cursor: pointer;
      margin-top: 12px;
      pointer-events: auto; /* Ensure button is clickable */
  }

  .image-preview-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .image-preview {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover; /* This makes the image cover the container, cropping if necessary */
  }

  .image-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.4);
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 1rem; /* Add space between the two buttons */
      opacity: 0;
      transition: opacity 0.2s ease-in-out;
      pointer-events: none; /* Pass clicks through unless on a button */
  }

  .image-preview-wrapper:hover .image-overlay {
      opacity: 1;
      pointer-events: auto; /* Enable clicks on the overlay when visible */
  }

  .overlay-button {
    background-color: rgba(255, 255, 255, 0.9);
    color: #374151;
    border: 1px solid #d1d5db;
    padding: 8px 16px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.9rem;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: background-color 0.2s ease-in-out;
  }

  .overlay-button:hover {
      background-color: #fff;
  }

  .overlay-button.remove-button:hover {
    background-color: #fee2e2; /* Light red */
    border-color: #fca5a5;
    color: #b91c1c;
  }

  .overlay-button .icon {
    width: 20px;
    height: 20px;
    margin: 0;
  }
`;
